var __TEMP__ = require('./_listCacheClear.js');var listCacheClear = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_listCacheDelete.js');var listCacheDelete = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_listCacheGet.js');var listCacheGet = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_listCacheHas.js');var listCacheHas = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_listCacheSet.js');var listCacheSet = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = ListCache;
